export const buildClientsSummary = (clients) => {
    const list = clients || [];
    const connections = list.reduce((total, client) => total + (client.connectedTo || []).length, 0);
    const mandate = list.length === 1 ? "Mandant" : "Mandanten";

    return `${list.length} ${mandate} · ${connections} API-Verbindungen`;
};
